//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getInstagramShopsFeatureUgcFlags } from '@instagram-account/redux/instagram-shops/selectors/getInstagramShopsFeatureUgc';

export const getShouldRequestNextItems = createSelector(
  getInstagramShopsFeatureUgcFlags,
  ({ hasFetchedAllItems, isFetchingNextItems }) =>
    !hasFetchedAllItems && !isFetchingNextItems,
);
